/* tslint:disable */
/* eslint-disable */
/**
 * FreightSimple Hubble API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 0.0
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from "../runtime";
import type { PresenceViewer } from "./PresenceViewer";
import {
  PresenceViewerFromJSON,
  PresenceViewerFromJSONTyped,
  PresenceViewerToJSON,
  PresenceViewerToJSONTyped,
} from "./PresenceViewer";
import type { PresenceRecentEditor } from "./PresenceRecentEditor";
import {
  PresenceRecentEditorFromJSON,
  PresenceRecentEditorFromJSONTyped,
  PresenceRecentEditorToJSON,
  PresenceRecentEditorToJSONTyped,
} from "./PresenceRecentEditor";
import type { PresenceFieldEdit } from "./PresenceFieldEdit";
import {
  PresenceFieldEditFromJSON,
  PresenceFieldEditFromJSONTyped,
  PresenceFieldEditToJSON,
  PresenceFieldEditToJSONTyped,
} from "./PresenceFieldEdit";

/**
 *
 * @export
 * @interface PresenceResponse
 */
export interface PresenceResponse {
  /**
   *
   * @type {Array<PresenceViewer>}
   * @memberof PresenceResponse
   */
  viewers: Array<PresenceViewer>;
  /**
   *
   * @type {Array<PresenceFieldEdit>}
   * @memberof PresenceResponse
   */
  fieldEdits: Array<PresenceFieldEdit>;
  /**
   *
   * @type {Array<PresenceRecentEditor>}
   * @memberof PresenceResponse
   */
  recentEditors: Array<PresenceRecentEditor>;
}

/**
 * Check if a given object implements the PresenceResponse interface.
 */
export function instanceOfPresenceResponse(
  value: object,
): value is PresenceResponse {
  if (!("viewers" in value) || value["viewers"] === undefined) return false;
  if (!("fieldEdits" in value) || value["fieldEdits"] === undefined)
    return false;
  if (!("recentEditors" in value) || value["recentEditors"] === undefined)
    return false;
  return true;
}

export function PresenceResponseFromJSON(json: any): PresenceResponse {
  return PresenceResponseFromJSONTyped(json, false);
}

export function PresenceResponseFromJSONTyped(
  json: any,
  ignoreDiscriminator: boolean,
): PresenceResponse {
  if (json == null) {
    return json;
  }
  return {
    viewers: (json["viewers"] as Array<any>).map(PresenceViewerFromJSON),
    fieldEdits: (json["fieldEdits"] as Array<any>).map(
      PresenceFieldEditFromJSON,
    ),
    recentEditors: (json["recentEditors"] as Array<any>).map(
      PresenceRecentEditorFromJSON,
    ),
  };
}

export function PresenceResponseToJSON(json: any): PresenceResponse {
  return PresenceResponseToJSONTyped(json, false);
}

export function PresenceResponseToJSONTyped(
  value?: PresenceResponse | null,
  ignoreDiscriminator: boolean = false,
): any {
  if (value == null) {
    return value;
  }

  return {
    viewers: (value["viewers"] as Array<any>).map(PresenceViewerToJSON),
    fieldEdits: (value["fieldEdits"] as Array<any>).map(
      PresenceFieldEditToJSON,
    ),
    recentEditors: (value["recentEditors"] as Array<any>).map(
      PresenceRecentEditorToJSON,
    ),
  };
}
